import Api from 'src/api/Base'

class GetSpacePlanTitles extends Api {
  requestUrl = `/api/SpacePlan/Titles`
}

export default GetSpacePlanTitles
